import { References, BeforeAfter, RealProjects } from "../components/References";
import { CtaBand } from "../components/CtaBand";
import { useTitle } from "../components/Reveal";

export default function Referenzen() {
  useTitle("Referenzen – Manfred Berglar · Malermeister seit 1925");
  return (
    <div className="bg-white text-ink overflow-x-clip">
      <h1 className="sr-only">Referenzen – Projekte von Manfred Berglar, Malermeister aus Olpe</h1>
      <div className="pt-[76px] md:pt-[88px]">
        <RealProjects />
        <References />
        <BeforeAfter />
        <CtaBand
          title="Ihr Projekt könnte das nächste sein."
          text="Ob Fassade, Innenraum oder Sanierung – wir zeigen Ihnen gern, was möglich ist."
        />
      </div>
    </div>
  );
}
